import { Injectable } from '@angular/core';
import { I18nService } from 'i18n/i18n.service';
import { IAuthenticationMethod } from 'app/security/core/typings/IAuthentication';
import { AuthenticationProperties } from '../../core/enums/authentication-types.enum';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationListUtils {

    constructor(private _i18nService: I18nService) { }

    processAuthenticationItems(selectedMethod: IAuthenticationMethod, selectedMetadata: any): any[] {
        if (!selectedMethod || !selectedMetadata) {
            return [];
        }

        let items = this.returnItems(selectedMethod);

        if (selectedMetadata) {
            items = items.filter(item => {
                return (item.key ? selectedMetadata[item.key] : selectedMetadata[item.name]) !== undefined;
            });
        }

        return this.sortItems(items);
    }

    returnItems(selectedMethod: IAuthenticationMethod) {
        let items = null;

        if (selectedMethod[AuthenticationProperties.OAUTH_OPTIONS]) {
            const activeFlow = selectedMethod[AuthenticationProperties.OAUTH_OPTIONS].activeFlow;
            const flows = selectedMethod[AuthenticationProperties.OAUTH_OPTIONS].flows;
            
            if (activeFlow && flows && flows.length > 0) {
                const targetFlow = flows.find(flow => flow.name === activeFlow);
                items = targetFlow ? targetFlow.properties : flows[0].properties;
            } else if (flows && flows.length > 0) {
                items = flows[0].properties;
            } else {
                items = [];
            }
            
        } else {
            items = Object.entries(selectedMethod[AuthenticationProperties.OPTIONS]).map(([key, value]) => ({ key, value }));
        }
        return items;
    }

    sortItems(items: any[]): any[] {
        if (!items) {
            return items;
        }

        const itemsWithTranslations = items.map((newItem) => {
            const newItemWithTranslation = { ...newItem };
            let nameToTranslate = 'AUTHENTICATION.OPTIONS_' + (newItem.key || newItem.name);
            newItemWithTranslation.translation = this._i18nService.instant(nameToTranslate);
            return newItemWithTranslation;
        });

        return itemsWithTranslations.sort((a, b) => a.translation.localeCompare(b.translation));
    }
}